module.exports = __webpack_public_path__ + "img/csr_swiper_01.7edcfb22.jpg";